/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'
import {GameTypeEnum} from '~/pages/game/components/utils'
import {freePlayActionTypeEnum} from '~/pages/game/LuckySlot/enum'
import {getGameId} from './constant'

export {GameTypeEnum}

export enum StatusEnum {
  // 0:下注阶段;1:开奖中阶段;2:开奖结果展示阶段
  bet = 0,
  preparing = 1,
  showRes = 2,
}
export enum JackpotStatusEnum {
  // 0:未开启;1:开启中;
  turnOff = 0,
  turnOn = 1,
}

export enum GpsJackpotStatusEnum {
  // 0:未开启;1:蓄力中;2:抢夺中
  off = 0,
  xunLi = 1,
  qiangDuo = 2,
}
export enum resStatusEnum {
  // 0: 未参与本轮;2:赢了;1:输了
  notInvolved = 0,
  win = 2,
  lose = 1,
}
export enum RankTypeEnum {
  // 榜单类型: 1: 日榜;2:周榜;3:月榜
  daily = 1,
  week,
  monthly,
}

// export enum GameTypeEnum {
//   猜宝箱 = 1,
//   greedyHiya = 2,
//   tp = 3,
//   新转盘 = 4,
//   slot = 5,
//   greedypro = 6,
//   roulette = 12,
//   greedyBox = 13,
// }
export enum ActionTypeEnum {
  none = 0, // 无任何交互
  reward = 1, // 领取免单卡弹窗交互
  card = 2, // 有未使用的免单卡弹窗教诲, 对应card_list 字段信息
  entry = 3, // 展示限时回归任务入口，对应jobs_enter字段信息
}
// 免费玩任务状态
export enum FreePlayStatusEnum {
  未完成 = 0,
  完成未领取 = 1,
  完成已领取 = 2,
}
// 免费玩行为类型
export enum FreePlayActionTypeEnum {
  非目标用户 = 0,
  命中奖励 = 1,
  免费任务有效 = 2,
}

export const greedy_homepage = createAsyncThunk(
  'greedy_pro_homepage',
  async (arg, store: any) => {
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/ground/gy_p_homepage',
      {
        ...deviceinfo,
        game_id: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const greedy_homepage_status = createAsyncThunk(
  'greedy_homepage_status',
  async (arg, store: any) => {
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/ground/gy_p_homepage',
      {
        ...deviceinfo,
        game_id: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const jackpot_homepage = createAsyncThunk(
  'jackpot_homepage',
  async (arg, store: any) => {
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/ground/jt_homepage',
      {
        ...deviceinfo,
        game_id: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
      },
      {store}
    )
    return resp.data.data
  }
)
export const gps_jackpot_homepage = createAsyncThunk(
  'gps_jackpot_homepage',
  async (arg, store: any) => {
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/ground/gps_jt_homepage',
      {
        ...deviceinfo,
        game_id: getGameId(path),
        is_webview_banner: false,
      },
      {store}
    )
    return resp.data.data
  }
)
export const greedy_result = createAsyncThunk(
  'greedy_pro_result',
  async (arg: {round_no: string}, store: any) => {
    // 每次获取开奖结果的时候将之前的结果清空
    await store.dispatch(GameGreedyProSlice.actions.resetBetRes())
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'reward_coins'
          | 'bet_coins'
          | 'round_result'
          | 'round_rank'
          | 'status'
          | 'day_round'
          | 'round_target'
        >
      >
    >(
      '/live/ground/gy_p_result',
      {
        ...deviceinfo,
        game_id: getGameId(path),
        ...arg,
      },
      {store}
    )
    return resp.data.data
  }
)
export const getGreedyProBet = createAsyncThunk(
  'getGreedyProBet',
  async (arg: {target_id: number; bet_coins: number}, store: any) => {
    const {
      deviceinfo,
      path,
      otherInfo: {from},
    } = store.getState().env
    const resp = await http.post<HiyaRes<any>>(
      '/live/ground/gy_p_bet',
      {
        ...deviceinfo,
        game_id: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
        ...arg,
        source: from,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const getGamesCallbackInfo = createAsyncThunk(
  'getGreedyProGamesCallbackInfo',
  async (arg: {game_type?: GameTypeEnum}, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/activity/games_callback_info',
      {
        ...deviceinfo,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const greedypro_newer_fplay_main = createAsyncThunk(
  'greedypro_newer_fplay_main',
  async (arg, store: any) => {
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/ground/gy_p_newer_fplay_main',
      {
        ...deviceinfo,
        game_id: getGameId(path),
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface res_type {
  target_id: number
  icon: string
}

export interface round_res_type extends res_type {
  big_reward_flag: boolean
  big_reward_type?: 1 | 2
  round_no?: string
  round_target: number
}
interface food_res_type extends res_type {
  name: string
}
export interface normal_target_res_type extends food_res_type {
  odds: number
  hot_topn: number
  bet_amounts: number
}
export interface order_log_list_type {
  round_no: string
  win_num: number
  ct: string
}
interface round_rank_type {
  avatar: string
  coin_nums: number
  name: string
  rank_no: number
  zy_id: string
}
interface jackpot_type {
  status?: JackpotStatusEnum
  jackpot_pool?: number
  jackpot_before?: number
  job_id?: number
  job_done?: number
  job_need?: number
  done_jobs?: Array<number>
  count_down?: number
  job_reset_count_down?: number
  reward_pool?: Array<{icon: string; name: string}>
  reward_idx?: number
  jackpot_ratio?: number
  coin_num?: number
  jackpot_st?: string
  jackpot_et?: string
}
interface gps_jackpot_type {
  status?: GpsJackpotStatusEnum
  count_down?: number
  super_jackpot_guide?: boolean
  super_jackpot_round?: number
  super_jackpot?: number
  champion_info?: any
  champion_score?: number
  reward_need_score?: number
  my_score?: number
  jackpot_open_need?: number
  open_days?: Array<string>
  open_hours?: Array<string>
}
export interface loading_conf {
  bg: string
  outerProcess: string
  process: string
  text: string
}
export interface betArea_conf {
  title: string
  chip: string
  chipSelected: string
  result: string
  resultBg: string
  fixedDesc: string
  fixedCount: string
}
export interface main_conf {
  betText: string
  betSelectedText: string
  time: string
  betDesc: string
}
export interface jackpot_conf {
  rateText: string
  jackpotText: string
  winBtnText: string
  winText: string
}
export interface betRecord_conf {
  bg: string
  titleColor: string
  listBg: string
  coinCountColor: string
  roundColor: string
  dateColor: string
}
export interface resultPop_conf {
  bg: string
  titleColor: string
  roundNoTextColor: string
  roundNoCountColor: string
  betTextColor: string
  betCountColor: string
  winTextColor: string
  winCountColor: string
  bigWinnerTitleColor: string
  bigWinnerNameColor: string
  bigWinnerCountColor: string
  descBg: string
  countTimeBg: string
  countTimeColor: string
}
export interface gameRank_conf {
  bg: string
  tabBg: string
  tabSelectedBg: string
  tabTextColor: string
  tabTextSelectedColor: string
  ownBg: string
  titleColor: string
  coinCountColor: string
  nameColor: string
  rankColor: string
  ownRankColor: string
  ownNameColor: string
  ownCoinCountColor: string
}
export interface winRecord_conf {
  bg: string
  evenBg: string
  oddBg: string
  titleColor: string
  labelColor: string
  borderColor: string
}
export interface jackpotRule_conf {
  bg: string
  titleColor: string
  textColor: string
}
export interface gameRule_conf {
  bg: string
  titleColor: string
  subTitleColor: string
  textColor: string
}

export interface free_card_info {
  value: number
  num: number
  game_type: GameTypeEnum
}
export interface recall_conf {
  game_url?: string
  action_type: ActionTypeEnum
  jobs_enter: {
    exist_reward_gain: boolean
    count_down: number
  }
  member?: {
    name: string
    mid: number
    zy_id: string
  }
  tipShow?: boolean
  free_cards_reward: Array<free_card_info>
  card_list: Array<free_card_info>
  op_free_cards_reward: Array<free_card_info>
  freeCardListObj?: any
}

interface freePlay_task_info {
  job_id: number
  status: FreePlayStatusEnum
  target_num: number
  done_num: number
  coin_num: number
  job_name: string
  reward_icon: string
  reward_name: string
}
interface InitialStateType {
  // 主页面数据
  img_ui_config?: any
  ui_config?: any
  // 当前在线玩家
  playing_users?: number
  // 开奖轮次唯一性ID
  round_no?: string
  // 当前轮次/日
  day_round?: number
  // 金币余额
  coin_num?: number
  // 今日赢钱总数
  today_win?: number
  // 普通食物列表
  target_list?: Array<normal_target_res_type>
  // 	当前轮次的状态:0:下注阶段;1:开奖中阶段;2:开奖结果展示阶段
  round_status?: number
  // 	当轮次状态为:开奖结果展示阶段时，展示开奖的结果
  round_result?: round_res_type
  round_target?: number
  // 	当前状态的剩余时间: 秒数
  status_expire?: number
  // 	用户单轮最多下注的食物种类
  max_select_foods?: number
  // 	单次可下注金额列表
  bet_prices?: Array<number>
  // 	历史期号开奖阶段，按开奖期号倒序排列
  history_result?: Array<round_res_type>
  // 	当日的中奖金额日榜top3
  day_rank?: Array<ListItemType>
  // 历史账单
  order_log_list?: Array<order_log_list_type>
  list?: Array<order_log_list_type>
  // 获取贪婪食物开奖结果
  // 防止和homePgae的day_round发生数据混淆
  res_day_round?: number
  // 赢取的金币数量
  reward_coins?: number
  // 本轮下注总金额
  bet_coins?: number
  // 本轮中奖金额top3
  round_rank?: Array<round_rank_type>
  status?: resStatusEnum
  // ---界面---
  // 是否loading
  betLoading?: boolean
  // targetIndex?: number
  // 是否下注过，如果下注过的话就不需要展示手势
  betted?: boolean
  // 配置样式
  styleConfig?: {
    loading: loading_conf
    betArea: betArea_conf
    main: main_conf
    jackpot: jackpot_conf
    betRecord: betRecord_conf
    resultPop: resultPop_conf
    winRecord: winRecord_conf
    jackpotRule: jackpotRule_conf
    gameRule: gameRule_conf
    gameRank: gameRank_conf
  }
  // 选择的下注金额下标
  betChip?: number
  jackpot?: jackpot_type
  showJackpotEndTip?: boolean
  jackpotAmising?: boolean
  usePag?: boolean
  canPlayJackpotAmis?: boolean
  playing?: boolean
  // 是否展示放大版jackpot
  showScaleJackpot?: boolean
  // 展示缩小jackpot
  showMinJackpot?: boolean
  gpsJackpot?: gps_jackpot_type
  legendGuide?: boolean
  gpsJackpotAmising?: boolean
  canPlayGpsAmising?: boolean
  recall?: recall_conf
  greedy_min_bet?: {
    price: number
    countdown: number
  }
  freePlay?: {
    action_type?: freePlayActionTypeEnum
    reward_countdown?: number
    expire_time?: string
    coin_card_expire_time?: string
    exist_reward_gain?: boolean
    daily_jobs?: Array<freePlay_task_info>
    game_jobs?: Array<freePlay_task_info>
  }
  hasPreAct?: boolean
  hasLoaded?: boolean
}

const initialState: InitialStateType = {}

const initData = {
  hasLoaded: false,
  hasPreAct: false,
  showJackpotEndTip: true,
  usePag: false,
  canPlayJackpotAmis: false,
  playing: true,
  showScaleJackpot: false,
  showMinJackpot: false,
  legendGuide: false,
  gpsJackpotAmising: false,
  canPlayGpsAmising: false,
  betLoading: true,
  recall: {
    action_type: ActionTypeEnum.none,
    jobs_enter: {
      exist_reward_gain: false,
      count_down: 0,
    },
    tipShow: true,
    card_list: [],
    free_cards_reward: [],
    op_free_cards_reward: [],
  },
  freePlay: {},
  gpsJackpot: {
    status: 0,
    count_down: 0,
    super_jackpot_guide: false,
    super_jackpot_round: 0,
    super_jackpot: 0,
    champion_info: null,
    champion_score: 0,
    reward_need_score: 0,
    my_score: 0,
    jackpot_open_need: 0,
    open_days: ['', ''],
    open_hours: ['', ''],
  },
}
export const GameGreedyProSlice = createSlice({
  name: 'Animal_Shark',
  initialState,
  reducers: {
    // hot_topn 当前轮次下注热榜排名,默认值:0(忽略),大于0才有意义
    updateHotFoods: (
      state,
      action: PayloadAction<{target_id: number; hot_topn: number}[]>
    ) => {
      if (!action.payload?.length) {
        return
      }
      const {target_list} = state
      target_list?.forEach((f, fIdx) => {
        const item = action.payload.find((nf) => nf.target_id === f.target_id)
        if (item) {
          target_list[fIdx].hot_topn = item.hot_topn || 0
        } else {
          // 如果更新的数组里面没有当前的下注物 就直接将当前的下注物置为不热门即可
          target_list[fIdx].hot_topn = 0
        }
      })
      Object.assign(state, {
        target_list,
      })
    },
    resetBetRes: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        reward_coins: undefined,
        bet_coins: undefined,
        round_result: undefined,
        round_rank: undefined,
        res_day_round: undefined,
      })
    },
    updateJackpot: (state, action: PayloadAction<any>) => {
      const {jackpot} = state
      Object.assign(state, {
        jackpot: {
          ...jackpot,
          ...action.payload,
        },
      })
    },
    changeBetLoading: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        betLoading: action.payload,
      })
    },
    changeJackpotAmising: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        jackpotAmising: action.payload,
      })
    },
    changeShowMinJackpot: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        showMinJackpot: action.payload,
      })
    },
    updateCanPlayJackpotAmis: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        canPlayJackpotAmis: action.payload,
      })
    },
    updateGpsJackpotAmising: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        gpsJackpotAmising: action.payload,
      })
    },
    updateCanPlayGpsAmising: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        canPlayGpsAmising: action.payload,
      })
    },
    updateUsePag: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        usePag: false,
      })
    },
    finishedPreAct: (state) => {
      Object.assign(state, {
        hasPreAct: true,
      })
    },
    finishedLoaded: (state) => {
      Object.assign(state, {
        hasLoaded: true,
      })
    },
    updateRecall: (state, action: PayloadAction<any>) => {
      const {recall} = state
      Object.assign(state, {
        recall: {
          ...recall,
          ...action.payload,
        },
      })
    },
    updateGpsJackpot: (state, action: PayloadAction<any>) => {
      const {gpsJackpot} = state
      Object.assign(state, {
        gpsJackpot: {
          ...gpsJackpot,
          ...action.payload,
        },
      })
    },
    updateShowJackpotEndTip: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        showJackpotEndTip: action.payload,
      })
    },
    updateShowScaleJackpot: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        showScaleJackpot: action.payload,
      })
    },
    updatePlaying: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        playing: action.payload,
      })
    },
    updateLegendGuide: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        legendGuide: action.payload,
      })
    },
    changeBetChip: (state, action: PayloadAction<number>) => {
      Object.assign(state, {
        betChip: action.payload,
      })
    },
    getWebMessage: (
      state,
      action: PayloadAction<{
        status_expire: number
        round_status: number
      }>
    ) => {
      Object.assign(state, action.payload)
    },
    initData: (state, action) => {
      Object.assign(state, initData)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(greedy_homepage.fulfilled, (state, action) => {
      const {img_ui_config, styleConfig = {}} = state
      const {
        round_status,
        target_list,
        ui_config,
        greedy_min_bet,
        bet_prices = [],
      } = action.payload
      const betPrices = bet_prices.slice()
      if (greedy_min_bet) {
        betPrices.unshift(greedy_min_bet.price)
      }
      // 默认的是否下注 是否的
      let betted = false
      // 只有是下注阶段的时候 才去检查是否有下注
      if (round_status === StatusEnum.bet) {
        betted = target_list?.some((f) => f.bet_amounts > 0)
      }
      // 判断配置是不是空对象
      const isSpace = Object.keys(ui_config || {}).length === 0
      Object.assign(
        state,
        {
          ...action.payload,
          bet_prices: betPrices,
          img_ui_config: isSpace ? img_ui_config : ui_config,
          styleConfig: isSpace
            ? styleConfig
            : JSON.parse(ui_config['style-1.json']),
          greedy_min_bet,
        },
        {betted}
      )
    })
    builder.addCase(gps_jackpot_homepage.fulfilled, (state, action) => {
      Object.assign(state, {gpsJackpot: action.payload})
    })
    builder.addCase(getGreedyProBet.fulfilled, (state, action) => {
      const {target_list, coin_num} = action.payload
      // 默认的是否下注 是否的
      let betted = false
      betted = target_list?.some((f) => f.bet_amounts > 0)
      if (target_list?.length) {
        Object.assign(state, {target_list, coin_num, betted})
      }
    })
    builder.addCase(jackpot_homepage.fulfilled, (state, action) => {
      const {jackpot} = state
      Object.assign(state, {
        jackpot: {
          ...jackpot,
          ...action.payload,
        },
      })
    })
    builder.addCase(greedy_result.fulfilled, (state, action) => {
      const {round_result, day_round, ...rest} = action.payload
      // 直接在获取本轮结果之后获得对应数组的index
      const ret = {
        // 防止和homepage数据混淆
        res_day_round: day_round,
      }

      Object.assign(state, action.payload, rest, {round_result}, ret)
    })
    builder.addCase(getGamesCallbackInfo.fulfilled, (state, action) => {
      Object.assign(state, {
        recall: {
          ...state.recall,
          ...action.payload,
        },
      })
    })
    builder.addCase(greedypro_newer_fplay_main.fulfilled, (state, action) => {
      Object.assign(state, {
        freePlay: {
          ...state.freePlay,
          ...action.payload,
        },
      })
    })
  },
})
export default GameGreedyProSlice.reducer
export const GameGreedyProActions = GameGreedyProSlice.actions
